<template>
  <div class="dashboard-container">
    <div
      v-if="loading"
      class="progress-bar"
      :style="{ width: progress + '%' }"
    ></div>
    <div class="mb-2 page-title">
      <i class="bi bi-file-earmark-text"></i> Match Clasification List
    </div>

    <div class="mb-2 d-flex justify-content-end align-items-center">
      <!-- Search Bar -->
      <!--input 
        v-model="searchQuery" 
        type="text" 
        class="form-control w-auto" 
        placeholder="Search" 
        @input="searchMembers" 
      /-->

      <!-- Create Menu Button -->
      <router-link to="/admin/match-clasification/create" class="button button-primary">
        <i class="bi bi-plus-square"></i> Add New
      </router-link>
    </div>

    <!-- Table to display navigation data -->
    <div class="table-responsive mt-3">
      <table class="table mb-0">
        <thead>
          <tr>
            <th>#</th>
            <th>Turnamen</th>
            <th>Kategori Pertandingan</th>
            <th>Kelompok Usia</th>
            <th>Nama Klasifikasi</th>
            <th class="nowrap">Biaya</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <!-- Wrapper element with v-if -->
        <tbody v-if="classes.length > 0">
          
          <tr v-for="(class_category, index) in classes" :key="class_category.id">
            <td>{{ index + 1 + (currentPage - 1) * perPage }}</td>
            <td>{{ class_category.tournament?.name }}</td>
            <td>{{ class_category.match_category?.name }}</td>
            <td>{{ class_category.age_category?.name }}</td>
            <td>{{ class_category.name }}</td>
            <!--
              Kosong ditulis "ikut kategori", bukan "Rp 0".
              NULL berarti biayanya mengikuti kategori induk; menampilkannya
              sebagai nol rupiah akan membuat panitia mengira acaranya gratis.
            -->
            <td class="nowrap">{{ rupiah(class_category.registration_fee) }}</td>
            <td class="action-column">
              <div class="d-flex gap-2 justify-content-end">
          <MenuAksi v-slot="{ tutup }">
            <button type="button" class="aksi__item"
                    @click="tutup(); EditClasification(class_category.id)">
              <i class="bi bi-pencil-square"></i> Ubah
            </button>
            <button type="button" class="aksi__item aksi__item--bahaya"
                    @click="tutup(); konfirmasiHapus(class_category.id, class_category.name)">
              <i class="bi bi-trash"></i> Hapus
            </button>
          </MenuAksi>
        </div>
            </td>
          </tr>
        </tbody>
        <!-- Fallback message when there is no data -->
        <tbody v-else>
          <tr>
            <td colspan="6" class="text-center">No class found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination Controls -->
    <div class="d-flex justify-content-end mt-4">
      <AppPagination
        :current-page="currentPage"
        :total-pages="totalPages"
        :prev-page-url="prevPageUrl"
        :next-page-url="nextPageUrl"
        @change-page="changePage"
      />
    </div>

  </div>
</template>

<script>
import axios from "axios";
import API from "@/config/api";
import MenuAksi from "@/components/ui/MenuAksi.vue";
import AppPagination from "@/components/ui/AppPagination.vue";
import { useConfirm } from "@/composables/useConfirm";
import { useToast } from "vue-toastification";

axios.defaults.baseURL = API.API_BASE_URL;

export default {
  name: "ClasificationList",

  components: { MenuAksi, AppPagination },
  data() {
    return {
      classes: [], // Array to hold paginated team members
      searchQuery: "", // User's search input
      currentPage: 1, // Current page of results
      perPage: 10, // Results per page
      totalPages: 0, // Total number of pages
      prevPageUrl: null, // URL of the previous page
      nextPageUrl: null, // URL of the next page
      loading: false,
      progress: 0,
    };
  },
  mounted() {
    this.loadClasses(); // Load menu data when the component is mounted
  },
  setup() {
    const { konfirmasi } = useConfirm();
    const toast = useToast();
    return { konfirmasi, toast };
  },

  methods: {
    /** "Rp 250.000", atau keterangan bila biayanya mengikuti kategori. */
    rupiah(nilai) {
      if (nilai === null || nilai === undefined || nilai === '') return 'ikut kategori';
      const angka = Number(nilai);
      if (!Number.isFinite(angka)) return 'ikut kategori';
      return new Intl.NumberFormat('id-ID', {
        style: 'currency', currency: 'IDR', maximumFractionDigits: 0,
      }).format(angka);
    },

    async konfirmasiHapus(id, nama = '') {
      const setuju = await this.konfirmasi({
        title: 'Hapus klasifikasi?',
        message: 'Klasifikasi ini akan dihapus dari turnamen.',
        itemName: nama,
        confirmText: 'Ya, hapus',
      });
      if (setuju) await this.hapusKlasifikasi(id);
    },

    async hapusKlasifikasi(id) {
      try {
        await axios.delete(`/match-clasifications/${id}`);
        this.toast.success('Klasifikasi dihapus.');
        // Halaman dimuat ulang, bukan barisnya dibuang dari array:
        // jumlah halaman ikut berubah setelah penghapusan.
        await this.loadClasses(this.currentPage);
      } catch (error) {
        // Pesannya sudah ditampilkan interceptor axios.
      }
    },

    async loadClasses(page = 1) {
      this.loading = true;
      try {
        const response = await axios.get("/match-clasifications", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`, // Assumes token is in localStorage
          },
          params: {
            page,
            perPage: this.perPage,
            search: this.searchQuery.trim(),
          },
        });
        const {
          current_page,
          last_page,
          data,
          next_page_url,
          prev_page_url,
        } = response.data;

        this.classes = data; // Assign team members
        this.currentPage = current_page; // Current page
        this.totalPages = last_page; // Total pages
        this.nextPageUrl = next_page_url; // Next page URL
        this.prevPageUrl = prev_page_url; // Previous page URL
        this.loading = false;
      } catch (error) {
        console.error("Error loading members:", error);
      }
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.loadClasses(page);
      }
    },


    searchClasses() {
      this.currentPage = 1; // Reset to page 1 for new search
      this.loadClasses();
    },

    async EditClasification(id) {
      this.$router.push({ name: "EditClasification", params: { id } });
    },

    deleteMenu(id) {
      // Implement logic to delete the menu (e.g., API call)

      // Parameter dipertahankan untuk saat fungsi ini diimplementasikan.

      void id;
    },
  },
  computed: {
    prevPageExists() {
      return this.currentPage > 1;
    },
    nextPageExists() {
      return this.currentPage < this.totalPages;
    },
  },
};
</script>

<style scoped>

.table th,
.table td {
  padding: 10px;
}






.form-control {
  width: 250px;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 5px;
  background: var(--grad-flame);
  animation: loader-animation 1.5s infinite;
}

/* Animasi garis loader */
@keyframes loader-animation {
  0% {
    width: 0;
    background: var(--grad-flame); /* Warna awal */
  }
  50% {
    width: 50%;
    background: var(--grad-flame); /* Warna saat animasi */
  }
  100% {
    width: 100%;
    background: var(--grad-flame);
  }
}
</style>
